
import React, { Component } from "react";
import axios from "axios";
import { Observable, Observer } from "rxjs";
import CryptoJS from "crypto-js";
import io from "socket.io-client";
import alertify from "alertifyjs";
import moment from 'moment-timezone'


const selectedDate = '03-12-20 12:40 PM';
const FORMAT = 'DD-MM-YY hh:mm A';

const getTimeZoneDiff = () => {
    let now = moment();
    let localOffset = now.utcOffset();
    now.tz('US/Mountain'); // your time zone, not necessarily the server's
    let centralOffset = now.utcOffset();
    return localOffset - centralOffset;
};

let date = moment(selectedDate, FORMAT).toISOString();
let result = moment(selectedDate, FORMAT).add(-getTimeZoneDiff(), 'minutes').toISOString();

var socket;
class service extends Component {
  loader = "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
  countryType = [ "Select Country","Afghanistan", "Aland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Saint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Canary Islands", "Cape Verde", "Cayman Islands", "Central African Republic", "Ceuta and Melilla", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo, Democratic Republic of", "Congo, Republic of", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia/Hrvatska", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and McDonald Islands", "Holy See (City Vatican State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federal State of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles (Deprecated)", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Island", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion Island", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Serbia and Montenegro (Deprecated)", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovak Republic", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia", "South Sudan", "Spain", "Sri Lanka", "St. Pierre and Miquelon", "State of Palestine", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkiye", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "US Minor Outlying Islands", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (USA)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"]
  eventiveDisplay = ['film','beyondFilm','partnerEvent','newFrontier']

  DPro = (data) => {
    // eslint-disable-next-line
    const bytes = CryptoJS.AES.decrypt(data, 'M+H)E?B\y8v5s2pXXp2s5v8y/B?E(H+M');
    try {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return []
    }
};
  e = (data) => {
    return CryptoJS.AES.encrypt(
      JSON.stringify(data),
     process.env.REACT_APP_SECRET_KEY
    ).toString();
  };

  decrypt = (data) => {
    return new Promise((resolve, reject) => {
      var bytes = CryptoJS.AES.decrypt(data,process.env.REACT_APP_SECRET_KEY);
      var decryptedData = []

      try {
        decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } catch (error) {
        decryptedData = []
      }

      return resolve(decryptedData);
    });
  };

  apiURL = process.env.REACT_APP_API_KEY;
  socketApi = process.env.REACT_APP_SOCKET_API_KEY;
  imageUrl = process.env.REACT_APP_IMAGE_URL;
  formaT = {
    location: "sundance-film",
    street: "partner",
    place: "us-east-1"
  };

  formbucketCSV = {
    location: "sundance-film",
    street: `screeningsCSV`,
    place: "us-east-1"
  }

  formbucketLocationCSV = {
    location: "sundance-film",
    street: `locationCSV`,
    place: "us-east-1"
  }

  formbucket = {
    location: "sundance-film",
    street: `assest/${process.env.REACT_APP_ENVIRONMENT}`,
    // street: "assest/development",
    place: "us-east-1"
  };

  formbucketAds = {
    location: "sundance-film",
    street: `assest/${process.env.REACT_APP_ENVIRONMENT}/ads`,
    place: "us-east-1"
  };

  connect = async (next) => {
    socket = io.connect(this.socketApi, {
      transports: ["websocket"],
    });
    socket.on("connect", () => {
      next(socket.connected);
    });
    socket.on("disconnect", () => {
      sessionStorage.setItem('reAuth', true)
      console.log(socket.id); // undefined
    });
  };

  postApi = (data) => {
    return axios.post(`${this.apiURL + data.api}`, data.value, {
      headers: {
        Authorization: localStorage.getItem("LoginToken"),
      },
    });
  };

  getApi = (data) => {
    return axios.get(`${this.apiURL + data.api}`, data);
  };


  sendevent = (e, Data) => {
    if(process.env.REACT_APP_DISABLE_ENCRYPTION === 'true')
    {
      return socket.emit("request", { event: e, data: Data });
    }
    else
    {
      return socket.emit("request", this.e({ event: e, data: Data }));
    }
  };

  createSafeStringObject = (defaultValue = '') => {
    let _self = this
    const safeObj = Object.create(String.prototype);
    safeObj.toString = () => defaultValue;
    safeObj.valueOf = () => defaultValue;
    safeObj[Symbol.toPrimitive] = () => defaultValue;
    return new Proxy(safeObj, {
      get(target, prop, receiver) {
        if (typeof prop === 'symbol' || 
            (typeof prop === 'string' && (prop.startsWith('$$') || prop.startsWith('_')))) {
          return Reflect.get(target, prop, receiver);
        }
        if (prop === 'toString' || prop === 'valueOf' || prop === Symbol.toPrimitive) {
          return Reflect.get(target, prop, receiver);
        }
        return _self.createSafeStringObject(defaultValue);
      }
    });
  };
  
  makeSafeData = (obj, defaultValue = '') => {
    let _self = this
    if (!obj || typeof obj !== 'object') return obj;
  
  
    return new Proxy(obj, {
      get(target, prop, receiver) {
        if (typeof prop === 'symbol' || (typeof prop === 'string' && prop.startsWith('$$'))) {
          return Reflect.get(target, prop, receiver);
        }
        const value = Reflect.get(target, prop, receiver);
        if (value === undefined) {
          // Special handling for date properties - check if prop contains "date" anywhere
          if (typeof prop === 'string' && prop.toLowerCase().includes('date')) {
            return new Date().toISOString();
          }
          return _self.createSafeStringObject(defaultValue);
        }
        
        if (typeof value === 'function') return value;
        if (typeof value === 'object' && value !== null) return _self.makeSafeData(value, defaultValue);
        
        return value;
      }
    });
  };
  
  getevent = () => {
    return Observable.create((observer) => {
        if(process.env.REACT_APP_DISABLE_ENCRYPTION === 'true')
        {
          socket.on("response", (data) => {
            observer.next(data);
          });
        }
        else
        {
          socket.on("response", async (data) => {
            var responseData = await this.decrypt(data)
            observer.next(responseData);
          });
        }
     
      socket.on("error", (data) => {
      });
    });
  };
  success = (msg) => {
    alertify.success(msg);
  };

  error = (msg) => {
    alertify.error(msg);
  };

  showEventive = (type) => {
    return this.eventiveDisplay.includes(type)
  }

  removeLocalstorage = () => {
    localStorage.removeItem("LoginToken");
  };
  chhoLe = (message, action) => {
    var pitaji = {
      _mataji: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      paneer: function(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = pitaji.samosa(input);
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output = output + this._mataji.charAt(enc1) + this._mataji.charAt(enc2) + this._mataji.charAt(enc3) + this._mataji.charAt(enc4);
        }
        return output;
      },
      bhurji: function(input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = this._mataji.indexOf(input.charAt(i++));
          enc2 = this._mataji.indexOf(input.charAt(i++));
          enc3 = this._mataji.indexOf(input.charAt(i++));
          enc4 = this._mataji.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        output = pitaji._sendwich(output);
        return output;
      },
      samosa: function(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if ((c > 127) && (c < 2048)) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }
        }
        return utftext;
      },
      _sendwich: function(utftext) {
        var string = "";
        var i = 0;
        var c = 0;
        var c1 = 0;
        var c2 = 0
        var c3= 0;
        while (i < utftext.length) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
            string += String.fromCharCode(c);
            i++;
          } else if ((c > 191) && (c < 224)) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
          } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
            i += 3;
          }
        }
        return string;
      }
    }
   return pitaji;

  }
}

export default service;
